import HeadTittle from "../../../components/HeadTittle";
import {permissionObj} from "../../../Helpers/permission";
import ButtonAction from "../../../components/buttons/ButtonAction";
import {AddIcon, TrashOutlineIconWhite} from "../../../components/buttons/IconButtons";
import React from "react";
import {DistributionCenterApp} from "./Funtionallity/DistributionCenterApp";
import DeleteModal from "../../Modals/DeleteModal";
import DistributionCenterTable from "./SubComponents/DistributionCenterTable";
import CustomAddNewEntityModal from "../../../components/Modal/CustomAddNewEntityModal";
import {
    CreateDistributionCenter,
    UpdateDistributionCenter
} from "../../../reduxToolkit/DistributionCenter/DistributionCenterApi";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const DistributionCenter = () => {

    const{
        DEV,
        permission,
        selectDistributionCenterForDelete,
        setSelectDistributionCenterForDelete,
        setDeleteDistributionCenter,
        isAllChecked,
        setIsAllChecked,
        setBodyForExport,
        searchElement,
        setSearchElement,
        option,
        search,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        modified,
        setModified,
        results,
        setResults,
        deleteDistributionCenter,
        deleteDistributionCenterModal,
        addShow,
        setAddShow,
        updateData,
        setUpdateData,
        isUpdate,
        setIsUpdate
    } = DistributionCenterApp();

    return (
        <>
            <HeadTittle  name={'distribution_center'}>
                {(DEV || permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_CREATE)) && (
                    <ButtonAction
                        id='btn_d_add'
                        name='create'
                        className='btn-icon-add'
                        Icon={AddIcon}
                        onClick={() => {
                            setAddShow(true);
                            setIsUpdate(false);
                        }}
                    />
                )}
                {(DEV || permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_DELETE)) && (
                    <ButtonAction
                        id='btn_d_delete'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectDistributionCenterForDelete?.length === 0}
                        Icon={TrashOutlineIconWhite}
                        onClick={() => {
                            setDeleteDistributionCenter(true);
                        }}
                    />
                )}
            </HeadTittle>

            <DistributionCenterTable
                isAllChecked={isAllChecked}
                setIsAllChecked={setIsAllChecked}
                selectedList={selectDistributionCenterForDelete}
                setSelectedList={setSelectDistributionCenterForDelete}
                setBodyForExport={setBodyForExport}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                optionTable={option}
                search={search}
                setSearch={setSearch}
                simpleSearch={simpleSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                results={results}
                setResults={setResults}
                name={'created_new_center'}
                textNoInformation={'no_distribution_center_text'}
                onClick={() => {
                    setAddShow(true);
                    setIsUpdate(false);
                }}
                setAddShow={setAddShow}
                setUpdateData={setUpdateData}
                setIsUpdate={setIsUpdate}
                setDeleteDistributionCenter={setDeleteDistributionCenter}
            />

            <CustomAddNewEntityModal
                show={addShow}
                onHide={() => setAddShow(false)}
                title="distribution_center"
                createAction={CreateDistributionCenter}
                updateAction={UpdateDistributionCenter}
                isUpdate={isUpdate}
                data={updateData}
                setModified={setModified}
                modified={modified}
            />

            <DeleteModal
                show={deleteDistributionCenter}
                onHide={() => setDeleteDistributionCenter(false)}
                data={selectDistributionCenterForDelete}
                onClickFn={() => deleteDistributionCenterModal(selectDistributionCenterForDelete)}
                title_modal={'delete_distribution_center'}
                element_modal={'distribution_center'}
                isReset={setSelectDistributionCenterForDelete}
                isAllReset={setIsAllChecked}
            />

        </>
    );
};

export default DistributionCenter;
